import { List } from "hooks/useHandleObjList"
import { validatePrice } from "utils/formatPrice"
import { PricingUnits, PricingUnitsLabel } from "../constants/defaultValues"
import { IDevModePricingVariables } from "../hooks/usePurchasePlan"
import { mapPricingCalculatorStrict, mapPricingExpression } from "./mapPricingVariables"

export const mapPurchasePlan = (purchasePlan: App.PurchasePlan) => {
  return {
    planKey: purchasePlan.planKey,
    name: purchasePlan.name,
    description: purchasePlan.description,
    fromPriceUnit: purchasePlan.fromPriceUnit,
    benefits: purchasePlan.benefits,
    product: purchasePlan.product,
    isEnterprise: purchasePlan.isEnterprise,
    isSimplifiedPricing: purchasePlan.isSimplifiedPricing,
    simplifiedPricing: purchasePlan.simplifiedPricing,
    devModePricing: purchasePlan.devModePricing,
    simplifiedPricingMode: purchasePlan.pricingUnit,
    price: purchasePlan.price
  }
}

const mapSimplifiedPricingParams = (params: {
  pricingVariablesList: List<App.ISimplePricingVariable>
  pricingUnit?: PricingUnits
  fromPrice?: string
  fromPriceUnit: string
}) => {
  const isMonthlyPlan = params.pricingUnit === PricingUnits.MONTHLY

  const eventTypes = params.pricingVariablesList.map((pricingVariable) => ({
    key: pricingVariable.eventType,
    limit: pricingVariable.usageLimit ?? undefined,
    isQuota: pricingVariable.isQuota ?? false
  }))

  const price = isMonthlyPlan ? validatePrice(params.fromPrice ?? "0") : undefined
  const fromPriceUnit = isMonthlyPlan ? PricingUnitsLabel.MONTHLY : params.fromPriceUnit

  return {
    simplifiedPricing: {
      eventTypes
    },
    price,
    fromPriceUnit
  }
}

export const mapPurchasePlanToSubmition = (
  purchasePlanForm: App.IPurchasePlanForm,
  benefitsList: List<App.IBenefitItem>,
  purchasePlanPricing: App.IPurchasePlanPricing,
  pricingVariablesList: List<App.ISimplePricingVariable>,
  devModePricing?: {
    expression?: IDevModePricingVariables
    calculator?: IDevModePricingVariables
  },
  pricingUnit?: PricingUnits
) => {
  let fromPriceUnit = purchasePlanPricing.fromPriceUnit

  let simplifiedPricingObj: Record<string, any> = {}

  let price: number | undefined

  if (purchasePlanPricing.isSimplifiedPricing) {
    const result = mapSimplifiedPricingParams({
      pricingVariablesList,
      pricingUnit,
      fromPrice: purchasePlanPricing.fromPrice,
      fromPriceUnit
    })

    simplifiedPricingObj = result.simplifiedPricing
    price = result.price
    fromPriceUnit = result.fromPriceUnit
  }

  let devModePricingObj: Record<string, any> = {}

  if (!purchasePlanPricing.isSimplifiedPricing) {
    devModePricingObj = {
      pricingExpression: {
        scope: devModePricing?.expression?.list.map(mapPricingExpression),
        strExpression: devModePricing?.expression?.mathExp
      },
      pricingCalculator: {
        scope: devModePricing?.calculator?.list.map(mapPricingCalculatorStrict),
        strExpression: devModePricing?.calculator?.mathExp
      }
    }
  }

  return {
    _id: "",
    planKey: purchasePlanForm.planKey,
    name: purchasePlanForm.name,
    description: purchasePlanForm.description,
    benefits: benefitsList.map((benefit) => benefit.value),
    fromPrice: purchasePlanPricing.fromPrice,
    fromPriceUnit,
    product: purchasePlanForm.product,
    isEnterprise: purchasePlanForm.isEnterprise,
    isSimplifiedPricing: purchasePlanPricing.isSimplifiedPricing,
    simplifiedPricing: simplifiedPricingObj,
    devModePricing: devModePricingObj,
    pricingUnit,
    price
  }
}
